import { css } from '@emotion/react'
import { toUnitNumber } from '@/lib/number'

type Props = {
  currency: string
  value: number
}

export const TotalFundraiseValues: React.VFC<Props> = (props) => {
  const unitNumber = toUnitNumber(props.value)
  return (
    <div
      css={css`
        display: flex;
        justify-content: end;
      `}
    >
      <div
        className="currency"
        css={css`
          margin-right: 2px;
        `}
      >
        {props.currency}
      </div>
      <div className="value">{unitNumber.value?.toFixed(1)}</div>
      <div className="unit">{unitNumber.unit}</div>
    </div>
  )
}
